<!-- 合并明细 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="margin-bottom: 10px">
            <div class="search-ctn-left">
                <el-button size="small" class="search-btn btn-primary" v-if="permission.disassAccount"
                    @click="disassAccount">{{ permission.disassAccount }}</el-button>
                <el-button v-if="permission.print" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{ permission.print }}</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="210px" prop="OrderCode" label="单号">
                    <template slot-scope="scope">
                        <div style="display: flex; flex-direction: row">
                            <i v-if="scope.row.OrderId"><el-link :underline="false" :href="scope.row.OrderType == 0
                                ? '/#/salesManage/salesOrder/check?id=' + scope.row.OrderId
                                : '/#/salesManage/salesReturns/edit_v3?type=1&SReturnId=' + scope.row.OrderId
                                " target="_blank">{{ scope.row.OrderCode }}</el-link></i>
                            <i v-else>{{ scope.row.OrderCode }}</i>
                            <img v-show="scope.row.OrderId" src="@/assets/images/preview.png" title="打印预览" style="margin-left: 5px; width: 24px; height: 24px"
                                @click.stop="viewOrderDetail(scope.row.OrderType, scope.row.OrderId)" />
                        </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="OrderType" label="单据类型">
                    <template slot-scope="scope">
                        <i v-if="scope.row.OrderType == 0" class="c-active">销售收款</i>
                        <i v-else-if="scope.row.OrderType == 1" class="out-active">销售退货</i>
                        <i v-else>建账</i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="PayTypeName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="应收总额">
                    <template slot-scope="scope">{{ scope.row.OrderType != 1 ? scope.row.TotalAmount : -scope.row.TotalAmount }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AgentAmount" label="代收总额">
                    <template slot-scope="scope">{{ scope.row.IsAgent ? scope.row.AgentAmount : 0 }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="75px" prop="SName" label="开单人"></el-table-column>
            </el-table>
        </div>
        <el-dialog :close-on-click-modal="false" :append-to-body="true" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printOrderPreview"
            width="870px">
            <div class="dialog-content" v-if="printOrderPreview">
                <printContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :showDisc="true" :isInit="true"></printContent>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :append-to-body="true" title="打印" :before-close="closeOrderPrintDialog" :visible.sync="printReturnPreview"
            width="870px">
            <div class="dialog-content" v-if="printReturnPreview">
                <printReturnContent @closeDialog="closeOrderPrintDialog" :printIds="idList" :isInit="true"></printReturnContent>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: '',
    props: ['RecordId','EntpCusName','isDefaultSet','isPreview'],
    components: {},
    data() {
        return {
            loading: false,
            tableData: [],
            permission: {},
            printOrderPreview: false,
            printReturnPreview: false,
            idList: [],
        };
    },
    mounted() {
        this.permission = this.$util.getPermission('CusReceivable_H');
        this.getDetails();
        this.getPrintComponents();
    },
    methods: {
        cancel() {
            this.$emit('closeDetails');
        },
        getDetails() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetCusCombineDetail',
                    hideLoading: true,
                    data: { RecordId: this.RecordId }
                })
                .then(res => {
                    if (!res.data) return;
                    res.data.map(x=>
                        x.EntpCusName = this.EntpCusName
                    )

                    this.tableData = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        disassAccount() {
            let recordId = this.RecordId;
            let that = this;
            this.$util.elConfirm({
                content: '您是否要拆解该条合并帐？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/RevenueManagement_H/DisassAccounts?recordId=${recordId}`,
                            hideLoading: true
                        })
                        .then(res => {
                            that.$util.successMsg('拆解成功');
                            that.$emit('closeDetails', true);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            });
        },
        viewOrderDetail(orderType, orderId) {
            if (orderId) {
                this.idList.push(orderId);
                if (orderType == 0) {
                    this.printOrderPreview = true;
                } else if (orderType == 1) {
                    this.printReturnPreview = true;
                }
            } else {
                this.$util.warningMsg('要打印的订单异常，请刷新后重新操作');
            }
        },
        print() {
            this.$emit('printPreview',this.tableData);

            // this.printDialogVisible = true;
        },
        closePrintDialog() {
            this.printDialogVisible = false;
        },
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                }
            });

            that.$util.getPrintComponents(4).then(data => {
                if (data) {
                    Vue.component('printReturnContent', () => import('@/components/printModels/' + data));
                } else {
                    Vue.component('printReturnContent', () => import('@/components/printModels/printSaleReturn'));
                }
            });
        },
        closeOrderPrintDialog() {
            this.printOrderPreview = false;
            this.printReturnPreview = false;
            this.idList = [];
        },
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}

.btn-ctn {
    text-align: right;
}

.el-row {
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }
}</style>
